export default __webpack_public_path__ + "static/media/apple.d67572f7.svg";